import { render } from "./Introduction.vue?vue&type=template&id=253085ef&scoped=true"
import script from "./Introduction.vue?vue&type=script&lang=ts"
export * from "./Introduction.vue?vue&type=script&lang=ts"

import "./Introduction.vue?vue&type=style&index=0&id=253085ef&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-253085ef"

export default script